import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface PcmpProposalSectionProps {
  title: string;
  actions?: ReactNode;
  className?: string;
  children: ReactNode;
}

export function PcmpProposalSection({
  title,
  actions,
  className,
  children,
}: PcmpProposalSectionProps) {
  return (
    <section
      className={cn(
        'flex min-w-0 flex-col gap-4 rounded-xl border bg-card p-5 shadow-sm',
        className,
      )}
    >
      <div className="flex flex-wrap items-center justify-between gap-2">
        <h2 className="text-lg font-semibold">{title}</h2>
        {actions ? <div className="flex flex-wrap items-center gap-2">{actions}</div> : null}
      </div>
      {children}
    </section>
  );
}
